/*
 * Player
 *
 * Ze player
 */

export default class Player extends Phaser.Group {

  constructor(parent, id, x, y) {
    super(parent.game, parent.game.world, id, false, false);

    this._i96 = {};
    this._i96.parent = parent;

    this._i96.id = id;

    // STOPPER
    // ----------
    this._i96.stopper_min = 70;
    this._i96.stopper_max = 156;
    this._i96.stopper_dist = this._i96.stopper_max - this._i96.stopper_min;
    this._i96.stopper    = this.create(125, 0, 'onager_stopper');

    // ARM
    // -----
    this._i96.arm_group = this._i96.parent.add.group(this.game.world, 'armgroup', false, false);
    // this._i96.arm = this._i96.parent.add.sprite(172, 125, 'onager_arm');
    this._i96.arm = this._i96.parent.add.sprite(0, 0, 'onager_arm');
    this._i96.arm_group.add(this._i96.arm);
    this._i96.arm_group.pivot.x = 190;
    this._i96.arm_group.pivot.y = 20;
    this._i96.arm_group.angle    = 0;
    this._i96.arm_group.x = 172;
    this._i96.arm_group.y = 145;
    this._i96.arm_min = 45;
    this._i96.arm_max = 80;
    this._i96.arm_dist = this._i96.arm_max - this._i96.arm_min;
    this.add(this._i96.arm_group);

    // CART
    // -----
    this._i96.cart       = this.create(0, 120, 'onager_cart');


    //  BOULDER
    // ----------
    this._i96.bullet_startx = -15;
    this._i96.bullet_starty = 98;
    this._i96.bullet_startx = 0;
    this._i96.bullet_starty = -20;
    this._i96.bullet_flying = false;
    this._i96.bullet = this.create(this._i96.bullet_startx, this._i96.bullet_starty, 'onager_boulder');
    // this._i96.bullet.exists = false;
    this._i96.parent.physics.arcade.enable(this._i96.bullet);
    this._i96.bullet.body.allowGravity = false;
    this._i96.bullet.checkWorldBounds = true;
    this._i96.bullet.events.onOutOfBounds.add(this._killBullet, this);
    this._i96.arm_group.add(this._i96.bullet, 0, 0);



    // FIREBUTTON
    // -------------
    this._i96.firebutton_down = 0;
    // this._i96.fireButton = this._i96.parent.input.keyboard.addKey( Phaser.Keyboard.SPACEBAR );
    // this._i96.fireButton.onDown.add(this._fire, this);


    this.tween = null;


    this.scale.setTo(0.5, 0.5);

    this.x = x;
    this.y = y;
    // this.position = [100, 390];

  }


  _fire() {
    console.log('FIREEEEEEEEEE');

    if (this._i96.bullet_flying)
    {
      return;
    }

    this._i96.parent.shotsDone++;
    this._i96.parent._showScore();


    this._i96.bullet_flying = true;
    //  Re-position the bullet where the turret is
    this._i96.bullet.reset(
        this._i96.bullet_startx,
        this._i96.bullet_starty);
    // this._i96.bullet.reset(
    //     this._i96.stopper.x,
    //     this._i96.stopper.y);



    this._i96.arm_group.angle = 0;

    this.targetangle = this._getArmAngleTarget();

    this._i96.firebutton_up = Date.now();
    this._i96.firebutton_power = -(this._i96.firebutton_up-this._i96.firebutton_down)*1.5;

    this._i96.arm_group.add(this._i96.bullet);

    this._i96.arm_tween = this._i96.parent.add.tween(
        this._i96.arm_group).to(
            { angle:  this.targetangle},
              1200+(this._i96.firebutton_power*0.4),
            "Quart.easeIn",
            false);
    console.log(this._i96.arm_group.x, this._i96.arm_group.y);
    this._i96.arm_tween.onComplete.add(function(){

      var px = this._i96.bullet.world.x;
      var py = this._i96.bullet.world.y;

      this._i96.arm_group.remove(this._i96.bullet);
      this.add(this._i96.bullet);

      this._i96.bullet.reset(
          this._i96.stopper.x-20,
          this._i96.stopper.y-20);
      // this._i96.bullet.reset(
      //     px,py
      //     );

      // var p = new Phaser.Point(this._i96.arm_group.x+190, this._i96.arm_group.y);
      //
      // p.rotate(p.x, p.y, this._i96.arm_group, false, 190);
      //
      // var y = this._i96.bullet.y;
      // var x = this._i96.bullet.x;
      // var ny = y*Math.cos(this.targetangle) - x*Math.sin(this.targetangle)
      // var nx = y*Math.sin(this.targetangle) + x*Math.cos(this.targetangle)
      //
      // console.log(nx, ny);
      // console.log(this._i96.bullet.x, this._i96.bullet.y);
      // console.log(this._i96.arm_group.x, this._i96.arm_group.y);

      // this._i96.bullet.reset(
      //
      // );

      //  Our launch trajectory is based on the angle of the turret and the power
      // var power = -(this._i96.firebutton_up-this._i96.firebutton_down)*1.5;
      var power = this._i96.firebutton_power;

      var angle = 90+this.targetangle;

      // console.log('shooting', this._i96.arm.angle, power, this._i96.bullet.body.velocity);

      this._i96.bullet.body.allowGravity = true;

      this._i96.parent.camera.follow(this._i96.bullet);

      this._i96.parent.physics.arcade.velocityFromAngle(
          angle,
          power,
          this._i96.bullet.body.velocity);

    }, this);
    this._i96.arm_tween.start();




  }



  _killBullet(slidemove) {
    this._i96.bullet.body.allowGravity = false;
    this._i96.bullet.reset(
        this._i96.bullet_startx,
        this._i96.bullet_starty);
    this._i96.bullet_flying = false;

    // reset camera
    this._i96.parent.camera.follow();
    if (slidemove) {
      this.tween = this._i96.parent.add.tween(this._i96.parent.camera).to( { x: 0 }, 1000, "Quint", true, 1000);
    }
    this._i96.arm_group.angle = 0;
    this.remove(this._i96.bullet);
    this._i96.arm_group.add(this._i96.bullet);
  }



  _update() {


    this._processBullet();


    this._processKeys();


  }



  hitTarget(bullet, target) {
    console.log('boom');
    target.kill();
    this._killBullet(true);
    this._i96.parent._updateScore();
  }



  _processBullet() {

    if (this._i96.bullet_flying)
    {
      //  Bullet vs. the Targets
      this._i96.parent.physics.arcade.overlap(
          this._i96.bullet,
          this._i96.parent.targets, this.hitTarget, null, this);
      //  Bullet vs. the land
      this._bulletVsLand();
    }


  }



  _bulletVsLand() {
    var x = Math.floor(this._i96.bullet.world.x);
    var y = Math.floor(this._i96.bullet.world.y)-400;
    // console.log(x, y);
    var rgba = this._i96.parent.floor.getPixel(x, y);
    if (rgba.a > 0)
    {
      // this._i96.parent.test();
      // console.log('hit', this._i96.parent.floor);
      this._i96.parent.floor.blendDestinationOut();
      this._i96.parent.floor.circle(x, y, 23, 'rgba(100, 100, 200, 255');
      // this._i96.parent.floor.circle(300, 100, 200, 'rgba(100, 100, 200, 255');
      this._i96.parent.floor.blendReset();
      this._i96.parent.floor.update();
      this._i96.parent.floor.dirty = true;
      //  If you like you could combine the above 4 lines:
      // this.land.blendDestinationOut().circle(x, y, 16, 'rgba(0, 0, 0, 255').blendReset().update();
      this._killBullet(true);
      // this._i96.parent.test();
    }
  }


  _getArmAngleTarget() {
      var current = this._i96.stopper.x - this._i96.stopper_min;
      var percent = current / this._i96.stopper_dist;
      return this._i96.arm_dist * percent + this._i96.arm_min;
  }


  _showAngle() {
    var angle = this._getArmAngleTarget()
    console.log('angle', angle);
    this._i96.arm_group.angle = angle;
  }





  _processKeys() {

    if (!this._i96.parent.gameRunning) {
      return;
    }

    // LEFT / RIGHT for stopper
    //---------------------------
    if (this._i96.parent.cursors.left.isDown && this._i96.stopper.x > this._i96.stopper_min) {
      this._i96.stopper.x--
      // this._showAngle();
    }

    else if (this._i96.parent.cursors.right.isDown && this._i96.stopper.x < this._i96.stopper_max)
    {
      this._i96.stopper.x++;
      // this._showAngle();
    }

    // UP / DOWN for arm
    if (this._i96.parent.cursors.up.isDown)
    {
      this._i96.arm_group.angle--;
      console.log(this._i96.arm_group.angle);
    }
    else if (this._i96.parent.cursors.down.isDown)
    {
      this._i96.arm_group.angle++;
      console.log(this._i96.arm_group.angle);
    }



    if (this._i96.parent.game.input.keyboard.isDown(Phaser.Keyboard.SPACEBAR))
    {
      // just started
      if (this._i96.firebutton_down == 0) {
        this._i96.firebutton_down = Date.now();
      }
      console.log(Date.now()-this._i96.firebutton_down);
    } else {
      // just stopped
      if (this._i96.firebutton_down !== 0) {
        // shoot
        this._fire();
        this._i96.firebutton_down = 0;
      }
    }
  }

}
